/**
 * Sort subscription plans by `sort_order` ascending (lower values first).
 * Use after fetch/filter so listings match admin ordering.
 */
export function sortSubscriptionPlansBySortOrder(plans) {
  if (!Array.isArray(plans)) return [];
  return [...plans].sort(
    (a, b) => (Number(a?.sort_order) || 0) - (Number(b?.sort_order) || 0)
  );
}
